import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/invitation-report';

class invitationReportService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default invitationReportService;



// WEBPACK FOOTER //
// ./src/services/invitationReportService.js